//#region Components
import CustomButton from "components/CustomButton/CustomButton";
//#endregion
//#region Icons
import ArrowIcon from "icons/ArrowIcon";
//#endregion

const NavigateButton = (props) => {
    return (
        <CustomButton 
            {...props}
            size={props.size || "medium"}
            height={props.height || "38px"}
            icon={<ArrowIcon/>}/>
    );
}

export default NavigateButton;